/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const weekAvailabilityDaysItemDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const weekAvailabilityDaysItemSlotsItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const weekAvailabilityDaysItemSlotsItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const weekAvailabilityDaysMin = 7
export const weekAvailabilityDaysMax = 7

export const weekAvailabilityNextWeekStartOneRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const weekAvailabilityPrevWeekStartOneRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const weekAvailabilityWeekStartRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const weekAvailabilityWindowFirstDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const weekAvailabilityWindowLastDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')

export const WeekAvailability = zod.object({
  days: zod
    .array(
      zod.object({
        closedReason: zod.string().nullable(),
        date: zod.string().regex(weekAvailabilityDaysItemDateRegExp),
        slots: zod.array(
          zod.object({
            end: zod.iso.datetime({ offset: true }).regex(weekAvailabilityDaysItemSlotsItemEndRegExp),
            start: zod.iso.datetime({ offset: true }).regex(weekAvailabilityDaysItemSlotsItemStartRegExp),
          }),
        ),
        status: zod.enum(['available', 'no_slots', 'closed', 'outside_window']),
      }),
    )
    .min(weekAvailabilityDaysMin)
    .max(weekAvailabilityDaysMax),
  nextWeekStart: zod.union([zod.string().regex(weekAvailabilityNextWeekStartOneRegExp), zod.null()]),
  prevWeekStart: zod.union([zod.string().regex(weekAvailabilityPrevWeekStartOneRegExp), zod.null()]),
  weekStart: zod.string().regex(weekAvailabilityWeekStartRegExp),
  window: zod.object({
    firstDate: zod.string().regex(weekAvailabilityWindowFirstDateRegExp),
    lastDate: zod.string().regex(weekAvailabilityWindowLastDateRegExp),
  }),
})

export type WeekAvailability = zod.input<typeof WeekAvailability>
export type WeekAvailabilityOutput = zod.output<typeof WeekAvailability>
